module.exports = __webpack_public_path__ + "img/360-produktion-svarv.4d819c00.jpg";